module.exports = __webpack_public_path__ + "media/assets/img/flags/zh-CN-b2da62f020089ccee92860e4defafdb4.png";